import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Injectable, ViewContainerRef } from '@angular/core';
import {
  AddNewSectionComponent,
  DeprecatedSectionComponent,
  AuthenticateUserComponent,
  AuthenticationRequiredComponent,
  BannerCarouselComponent,
  BannerGridSectionComponent,
  BannerSectionComponent,
  BlogListComponent,
  CarouselBannerComponent,
  CartComponent,
  CategoryProductComponent,
  CheckoutComponent,
  ChooseUsSectionComponent,
  ContactUsComponent,
  CustomerReviewComponent,
  EnrollmentFormComponent,
  FaqSectionComponent,
  FeaturedBrandComponent,
  FeaturedCategoryComponent,
  FeaturedCollectionComponent,
  FeaturedProductsComponent,
  FeaturesSectionComponent,
  FooterComponent,
  HeaderSectionComponent,
  HeaderTextComponent,
  ImageCarouselSectionComponent,
  ImageGridSectionComponent,
  ImageSectionComponent,
  LocationSectionComponent,
  LogoGalleryComponent,
  LogoShowcaseComponent,
  NewCollectionComponent,
  NewServicesComponent,
  NewsLetterComponentComponent,
  NewTestimonialsComponent,
  PricingSectionComponent,
  ProcessModernComponent,
  ProcessSectionComponent,
  ProductCategoryListComponent,
  ProductDescComponent,
  ProductListComponent,
  RecentBlogPostSectionComponent,
  RegistrationFormComponent,
  ReturnsCalculatorComponent,
  SchemeDetailComponent,
  SchemesComponent,
  ServiceSectionComponent,
  SkeletonLoaderSectionComponent,
  StoreListComponent,
  StorePageComponent,
  TeamMemberSectionComponent,
  TestimonialFullwidthComponent,
  TestimonialSectionComponent,
  TestimonialVideoComponent,
  TextImageSectionComponent,
  TextSectionComponent,
  UserProfileComponent,
  VerifyComponent,
  VideoSectionComponent,
  ViewBlogComponent,
  WhislistComponent,
  AppointmentBookingComponent,
  BookAppointmentComponent,
  ImageGridHotspotComponent,
  VideoGridSectionComponent,
  ReferEarnComponent,
  CondensedAndGradientComponent,
  FourFeaturesCenteredImageComponent,
  OverlappingImageComponent,
  ImageBackgroundComponent,
  ButtonGridSectionComponent,
  ProductInfoSectionComponent,
  FaqColumnsCardsComponent,
  VideoCarouselSectionComponent,
  FeatureExperienceSectionComponent,
  TestimonialSliderComponent,
  BrandStorySectionComponent,
  CountdownBannerComponent,
  MovingTextComponent
} from 'simpo-component-library';
import {
  BlogServiceService
} from '../master-config-components/micro-apps/website/edit-website/website-generationcomponent/blogs/blog-service.service';
import { StorageKeys } from '../shared-module-files/simpo.constant';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsiteGenerationService {

  componentsReferences = Array<ComponentRef<any>>()
  screenWidth: any;
  listComponents: any = [
    {
      sectionType: "referearn",
      component: ReferEarnComponent
    },
    {
      sectionType: 'banner',
      component: BannerSectionComponent
    },
    {
      sectionType: 'text',
      component: TextSectionComponent
    },
    {
      sectionType: 'image',
      component: ImageSectionComponent
    },
    {
      sectionType: 'text_image',
      component: TextImageSectionComponent
    },
    {
      sectionType: 'service',
      component: ServiceSectionComponent
    },
    {
      sectionType: 'testimonial',
      component: TestimonialSectionComponent
    },
    {
      sectionType: 'imagegrid',
      component: ImageGridSectionComponent
    },
    {
      sectionType: 'imageCarousel',
      component: ImageCarouselSectionComponent
    },
    {
      sectionType: 'video',
      component: VideoSectionComponent
    },
    {
      sectionType: 'videogrid',
      component: VideoGridSectionComponent
    },
    {
      sectionType: 'faqcolumnscards',
      component: FaqColumnsCardsComponent
    },
    {
      sectionType: 'buttongridsection',
      component: ButtonGridSectionComponent
    },
    {
      sectionType: 'productinfosection',
      component: ProductInfoSectionComponent
    },
    {
      sectionType: 'teammember',
      component: TeamMemberSectionComponent
    },
    {
      sectionType: "header",
      component: HeaderSectionComponent
    },
    {
      sectionType: "footer",
      component: FooterComponent
    },
    {
      sectionType: 'condensedandgradient',
      component: CondensedAndGradientComponent
    },
    {
      sectionType: 'fourfeaturesimage',
      component: FourFeaturesCenteredImageComponent
    },
    {
      sectionType: 'overlappingimage',
      component: OverlappingImageComponent
    },
    {
      sectionType: 'imagebackground',
      component: ImageBackgroundComponent
    },
    {
      sectionType: "addNewSection",
      component: AddNewSectionComponent
    },
    {
      sectionType: "contact us",
      component: ContactUsComponent
    },
    {
      sectionType: "section-loader",
      component: SkeletonLoaderSectionComponent
    },
    {
      sectionType: "faq",
      component: FaqSectionComponent
    },
    {
      sectionType: "bannerGrid",
      component: BannerGridSectionComponent
    },
    {
      sectionType: "chooseUs",
      component: ChooseUsSectionComponent
    },
    {
      sectionType: "pricing",
      component: PricingSectionComponent
    },
    {
      sectionType: "headerText",
      component: HeaderTextComponent
    },
    {
      sectionType: 'location',
      component: LocationSectionComponent
    },
    {
      sectionType: 'blogPost',
      component: RecentBlogPostSectionComponent
    },
    {
      sectionType: 'blogList',
      component: BlogListComponent
    },
    {
      sectionType: 'viewBlog',
      component: ViewBlogComponent
    },
    {
      sectionType: 'process',
      component: ProcessSectionComponent
    },
    {
      sectionType: 'processModern',
      component: ProcessModernComponent
    },
    {
      sectionType: 'feature',
      component: FeaturesSectionComponent
    },
    {
      sectionType: 'testimonialFullWidth',
      component: TestimonialFullwidthComponent
    },
    {
      sectionType: 'fourcoloumnwithcoloredicons',
      component: LogoShowcaseComponent
    },
    {
      sectionType: 'logoShowcase',
      component: LogoShowcaseComponent
    },
    {
      sectionType: 'featuredProduct',
      component: FeaturedProductsComponent
    },
    {
      sectionType: 'featuredcategory',
      component: FeaturedCategoryComponent
    },
    {
      sectionType: 'featuredbrand',
      component: FeaturedBrandComponent
    },
    {
      sectionType: 'productList',
      component: ProductListComponent
    },
    {
      sectionType: 'productDescription',
      component: ProductDescComponent
    },
    {
      sectionType: 'cart',
      component: CartComponent
    },
    {
      sectionType: 'checkout',
      component: CheckoutComponent
    },
    {
      sectionType: 'wishlist',
      component: WhislistComponent
    },
    {
      sectionType: 'profile',
      component: UserProfileComponent
    },
    {
      sectionType: 'authenticate',
      component: AuthenticateUserComponent
    },
    {
      sectionType: 'verify-payment',
      component: VerifyComponent
    },
    {
      sectionType: 'carouselBanner',
      component: CarouselBannerComponent
    },
    {
      sectionType: 'bannerCarousel',
      component: BannerCarouselComponent
    },
    {
      sectionType: 'categoryProduct',
      component: CategoryProductComponent
    },
    {
      sectionType: 'productCategoryList',
      component: ProductCategoryListComponent
    },
    {
      sectionType: 'customerReview',
      component: CustomerReviewComponent
    },
    {
      sectionType: 'featuredCollection',
      component: FeaturedCollectionComponent
    },
    {
      sectionType: 'login',
      component: AuthenticationRequiredComponent
    },
    {
      sectionType: 'testimonialVideo',
      component: TestimonialVideoComponent
    },
    {
      sectionType: 'appointment',
      component: DeprecatedSectionComponent
    },
    {
      sectionType: 'registrationForm',
      component: RegistrationFormComponent
    },
    {
      sectionType: 'admissionForm',
      component: RegistrationFormComponent
    },
    {
      sectionType: 'logoGallery',
      component: LogoGalleryComponent
    },
    {
      sectionType: 'newFooter',
      component: FooterComponent

    },
    {
      sectionType: 'assistance',
      component: NewServicesComponent
    },
    {
      sectionType: 'recommendation',
      component: NewTestimonialsComponent
    },
    {
      sectionType: 'featuredCollectionV2',
      component: NewCollectionComponent
    },
    {
      sectionType: 'newsLetter',
      component: NewsLetterComponentComponent
    },
    {
      sectionType: 'storeList',
      component: StoreListComponent
    },
    {
      sectionType: 'storePage',
      component: StorePageComponent
    },
    {
      sectionType: 'appointmentBooking',
      component: BookAppointmentComponent
    },
    {
      sectionType: 'enrollmentForm',
      component: EnrollmentFormComponent
    },
    {
      sectionType: 'returnsCalculator',
      component: ReturnsCalculatorComponent
    },
    {
      sectionType: 'schemes',
      component: SchemesComponent
    },
    {
      sectionType: 'schemeDetail',
      component: SchemeDetailComponent
    },
    {
      sectionType: 'bookAppointment',
      component: AppointmentBookingComponent
    },
    {
      sectionType: 'imagegridhotspot',
      component: ImageGridHotspotComponent
    },
    {
      sectionType: 'featuredcategoryv2',
      component: FeaturedCategoryComponent
    },
    {
      sectionType: 'featuredbrandv2',
      component: FeaturedBrandComponent
    },
    {
      sectionType: 'featuredproductv2',
      component: FeaturedProductsComponent
    },
    {
      sectionType: 'videocarousel',
      component: VideoCarouselSectionComponent
    },
    {
      sectionType: 'featureexperiencesection',
      component: FeatureExperienceSectionComponent
    },
    {
      sectionType: 'testimonialslider',
      component: TestimonialSliderComponent
    },
    {
      sectionType: 'brandStorysection',
      component: BrandStorySectionComponent
    },
    {
      sectionType: 'countdownbanner',
      component: CountdownBannerComponent
    },
    {
      sectionType: 'movingtext',
      component: MovingTextComponent
    }
  ];
  webStyleSheet = {
    'padding-left': '5%',
    'padding-right': '5%'
  }
  mobileStyleSheet = {
    'padding-left': '3%',
    'padding-right': '3%'
  }

  constructor(
    private comFactoryResolver: ComponentFactoryResolver,
    private blogService: BlogServiceService,
    private http: HttpClient
  ) {
    this.getScreenSize();
  }

  @HostListener("window: resize", ["$event"])
  getScreenSize() {
    this.screenWidth = window.innerWidth;
  }

  createDynamicComponents(displaySection: ViewContainerRef | any, sectionList: any[], edit, responseData?: any) {
    this.componentsReferences = [];
    displaySection?.clear()
    sectionList.forEach((section, index) => {
      for (let component of this.listComponents) {
        if (component.sectionType.toLowerCase() === section.sectionType.toLowerCase()) {
          let responseData;
          if (component.sectionType === 'blogPost' || component.sectionType === 'blogList') {
            this.updateSection(displaySection, index, section, edit)
            continue;
          }
          if (component.sectionType === 'viewBlog') {
            this.addComponent(displaySection, section, edit, index)
            continue;
          }
          const componentFactory = this.comFactoryResolver.resolveComponentFactory(component.component);
          const k = displaySection?.createComponent(componentFactory);
          if (!k) continue;
          k.instance.data = section;
          if (section.sectionType === 'header') {
            k.instance.nextComponent = sectionList[1];
          }
          k.instance.index = index;
          k.instance.responseData = section.responseData;
          k.instance.edit = edit;
          k.instance.nextComponentColor = sectionList[index + 1]?.styles?.background;

          if (section.sectionType.includes('banner')) {
            if (index != 1)
              delete k.instance.data.styles.merge;
            else
              k.instance.data.styles.merge = false;
          }

          this.componentsReferences.push(k);
        }
      }
    })

    return this.componentsReferences?.[0]?.instance?._eventService || null;
  }

  markSectionForCheck(sectionId: string): void {
    const ref = this.componentsReferences.find(r => r.instance?.data?.id === sectionId);
    ref?.changeDetectorRef.markForCheck();
  }

  addComponent(displaySection: ViewContainerRef | any, newComponment: any, edit: boolean, index: number, sectionType?: any) {
    let componentFact = this.listComponents.forEach(async (listCompos, i) => {
      if (listCompos.sectionType.toLowerCase() === newComponment.sectionType.toLowerCase()) {
        let responseData;
        if (newComponment.sectionType === 'viewBlog') {
          responseData = await this.blogService.getBlogByBlogId(newComponment.blogId)
        }

        const componentFactory = this.comFactoryResolver.resolveComponentFactory(listCompos.component);
        const k = displaySection.createComponent(componentFactory, index);
        k.instance.data = newComponment;

        if (responseData) {
          k.instance.responseData = responseData.data;
        }

        if (sectionType) k.instance.sectionType = sectionType;
        // if (sectionType.includes('banner')) {
        //   if (index != 1)
        //     delete k.instance.data.styles.merge;
        //   else
        //     k.instance.data.styles.merge = false;
        // }
        k.instance.edit = edit;

        k.instance.canEditAll = true;
        k.instance.index = index;

        this.componentsReferences.splice(index, 0, k);

        for (let i = index + 10 + 1; i < displaySection._lContainer.length; i++) {
          if (displaySection._lContainer[i][8].index) {
            displaySection._lContainer[i][8].index = displaySection._lContainer[i][8].index + 1;
          }
        }

      }
    });
    return this.componentsReferences?.[0]?.instance?._eventService || null;
  }

  updateSection(displaySection, index: number, newData: any, edit: boolean, sectionType?: any) {
    const componentToRemove = displaySection.get(index);
    if (componentToRemove) {
      componentToRemove.destroy();
    }

    this.componentsReferences.splice(index, 1);
    this.listComponents.forEach(async (listCompos, i) => {
      if (listCompos.sectionType.toLowerCase() === newData.sectionType.toLowerCase()) {
        let responseData;
        if (listCompos.sectionType === 'blogPost' || listCompos.sectionType === 'blogList') {
          let businessId = JSON.parse(String(localStorage.getItem('bDetails')))?.id;
          if (businessId) {
            responseData = await this.blogService.getBlogSynchronousByBuisnessId(businessId)
          } else {
            let subId = JSON.parse(String(localStorage.getItem(StorageKeys.INDUSTRY_DETAILS))).subIndustryId;
            responseData = await this.blogService.getBlogSynchronousByBuisnessId(null, subId);
          }

        }
        const componentFactory = this.comFactoryResolver.resolveComponentFactory(listCompos.component);
        const k = displaySection.createComponent(componentFactory, index);
        k.instance.data = newData;
        if (index == 1) {
          displaySection._lContainer[10][8].nextComponent = newData
        }
        k.instance.edit = edit;
        if (responseData) {
          k.instance.responseData = responseData.data;
        }

        k.instance.nextComponentColor = displaySection._lContainer[11 + index][8]?.data?.styles?.background;
        if (displaySection._lContainer[10 + index - 1][8]?.nextComponentColor)
          displaySection._lContainer[10 + index - 1][8].nextComponentColor = newData.styles.background;

        if (sectionType) k.instance.sectionType = sectionType;

        // if (listCompos.sectionType?.includes('banner')) {
        //   if (index != 1)
        //     delete k.instance?.data?.styles?.merge;
        //   else if (k?.instance?.data?.styles?.merge)
        //     k.instance.data.styles.merge = false;
        // }
        k.instance.index = index;
        this.componentsReferences.splice(index, 0, k);

      }
    });
    return this.componentsReferences?.[0]?.instance?._eventService || null;
  }

  replaceComponent(displaySection, oldItem, newItem, edit, all) {
    let a = this.listComponents.forEach((listComps, i) => {
      // if(listComps.name === oldItem.webComponentName){
      //   let componentClass = listComps.component
      //   const component = this.componentsReferences.find((component) => component.instance instanceof componentClass);
      //   if(!component) return ;
      //   const index = this.componentsReferences.indexOf(component);
      // const componentFactory = this.comFactoryResolver.resolveComponentFactory(listComps.component);
      // const k = displaySection.createComponent(componentFactory, index);

      //   if(index !== -1){
      //     displaySection.splice(index,1,k);
      //     this.componentsReferences.splice(index,k)
      //   }
      // }
      if (listComps.name === oldItem.webComponentName) {
        let oldCompClass = listComps.component;
        const component = this.componentsReferences.find((component) => component.instance instanceof oldCompClass);
        if (!component) return;
        const oldCompIndex = this.componentsReferences.indexOf(component);
        if (listComps.name === newItem.webComponentName) {
          let newCompClass = listComps.component;
          const componentFactory = this.comFactoryResolver.resolveComponentFactory(newCompClass);
          const k = displaySection.createComponent(componentFactory, oldCompIndex);
          this.componentsReferences.splice(oldCompIndex, 1, k)
        }
      }
    });
    return this.componentsReferences?.[0]?.instance?._eventHelper || null;
  }

  samePageRedirection(selectedPage, id) {
    let a = document.querySelectorAll('*[id]');
    let b;
    a.forEach((singleNode) => {
      if (singleNode.id === selectedPage.components[id]) {
        b = document.getElementById(singleNode.id);
        if (!b) return;
        b.scrollIntoView({ behavior: 'smooth' });
      }
    });
    return b;
  }

  externelUrls(newPage) {
    window.open(newPage, '_blank')
  }
  getComponentData(componentName: string) {
    return this.http.get(environment.baseUrl + `admin/v3/component/name?sectionType=${componentName}`)
  }
}
